export default __webpack_public_path__ + "static/media/business-6.2d190d2a.jpg";